'use client';
import { CatButton } from 'components/blocks-components';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import { useTranslations } from 'next-intl';
import styles from '../selected-equipment.module.scss';
import { capitalizeText } from '@cat-ecom/common/utils/commonUtils';

export const AddSerialButton = () => {
  const t = useTranslations();
  const {
    editEquipmentDrawer: { openDrawer: openEditEquipmentDrawer }
  } = useMyEquipmentDrawer();
  const buttonLabel = capitalizeText(t('MEQ_ADD_SERIAL_NUMBER'));

  return (
    <CatButton
      onClick={openEditEquipmentDrawer}
      variant="inline"
      className={styles['no-padding']}
      aria-label={buttonLabel}
      size="sm"
    >
      {buttonLabel}
    </CatButton>
  );
};
